import { nanoid } from 'nanoid';
import { Checkbox } from 'Components/atoms';
import { Typography } from 'Components/atoms';
import { FilterComponentProps } from 'Core-utils/types/types';
import { SearchBar } from 'Components/molecules';
import './styles.scss';
import { useMemo, useState } from 'react';

function CheckboxList<T>({
    options,
    handleCheckbox,
    selectedOptions,
    header = true,
    customDisplayOptions,
    hasSearchBar = false,
}: FilterComponentProps<T>) {
    const [searchInput, setSearchInput] = useState<string>('');

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(event.target.value);
    };

    const filteredOptions = useMemo(() => {
        const regex = new RegExp(searchInput, 'i');
        if (customDisplayOptions) {
            return Object.keys(customDisplayOptions).filter((key) => regex.test(customDisplayOptions[key]));
        }
        return options.filter((opt) => regex.test(opt as string));
    }, [searchInput, options, customDisplayOptions]);

    return (
        <>
            {header && (
                <div className="dropdown-header">
                    <Typography variant="body5" color="text-high-emphasis">
                        Filter
                    </Typography>
                </div>
            )}
            {hasSearchBar && (
                <div className="ps-2 pe-2">
                    <SearchBar value={searchInput} onChange={handleSearchChange} />
                </div>
            )}
            <form className="checkbox-list overflow-auto custom-scrollbar">
                {filteredOptions.map((option) => (
                    <Checkbox
                        labelProp={option as string}
                        key={`checkbox-list-${nanoid()}`}
                        handleCheckbox={handleCheckbox}
                        checked={(Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]).some(
                            (opt) => opt === String(option),
                        )}
                        customDisplayLabel={customDisplayOptions?.[option as string]}
                    />
                ))}
            </form>
        </>
    );
}

export default CheckboxList;
